*,
*::before,
*::after {
  box-sizing: border-box;
}

:host {
  user-select: none;
  display: inline-block;
}

.wui-segmented {
  position: relative;

  display: inline-flex;
  align-items: stretch;

  padding: 4px;
  border-radius: calc(infinity * 1px);

  background-color: var(--wui-color-surface-control, #dfdfdf);
}

.wui-segmented.is-disabled {
  cursor: not-allowed;
  opacity: 0.4;
}

.wui-segmented.is-disabled .wui-segmented-trigger.is-disabled {
  opacity: 1;
}

.wui-segmented-indicator {
  position: absolute;
  z-index: 0;
  top: 3px;
  bottom: 3px;
  left: var(--indicator-left, 0);

  width: var(--indicator-width, 0);
  border-radius: calc(infinity * 1px);

  background-color: var(--wui-color-surface-glass, rgb(250 250 250 / 0.34));

  /* transition 只在首帧定位后启用，避免组件进入视口时触发初始化动画 */
  .is-indicator-ready & {
    transition:
      left var(--wui-duration-trigger, 160ms) var(--wui-ease-slide, cubic-bezier(0.77, 0, 0.175, 1)),
      width var(--wui-duration-trigger, 160ms) var(--wui-ease-slide, cubic-bezier(0.77, 0, 0.175, 1));
  }
}
